function isInfinity(value) {
  return value === Infinity || value === -Infinity;
}

export { isInfinity };
